var Model = require("../types/Model");

module.exports = Model({
	name: "apprefresher",
	listeners
});

function listeners(){
	return {
		"mqtt:$/app/refresh": refresh_app
	};
}

function refresh_app(){
	this.emit("refresh:trigger:refresh");
}